import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { BENEFICIARY_TYPES } from '../../services/donationCampaignService';

const { FiUser } = FiIcons;

const inputCls = "w-full px-4 py-3.5 border-2 border-brand-dark rounded-2xl outline-none focus:border-accent-gold text-sm font-medium transition-colors";

const CampaignBeneficiaryFields = ({ form, update }) => {
  const selectedType = BENEFICIARY_TYPES.find(t => t.id === form.beneficiary_type);

  const updateDetail = (key, val) => {
    update('beneficiary_details', { ...form.beneficiary_details, [key]: val });
  };

  return (
    <div className="space-y-6">
      {/* Type selector */}
      <div>
        <p className="text-[10px] font-black uppercase tracking-widest text-accent-navy mb-3">Beneficiary Type *</p>
        <div className="grid grid-cols-2 gap-3">
          {BENEFICIARY_TYPES.map(t => (
            <button key={t.id} onClick={() => { update('beneficiary_type', t.id); update('beneficiary_details', {}); }}
              className={`flex items-start gap-3 p-4 rounded-2xl border-2 text-left transition-all ${
                form.beneficiary_type === t.id
                  ? 'border-accent-navy bg-accent-navy/5'
                  : 'border-brand-dark hover:border-accent-gold/50'
              }`}>
              <span className="text-2xl leading-none flex-shrink-0">{t.emoji}</span>
              <div>
                <p className={`text-[11px] font-black uppercase tracking-widest ${form.beneficiary_type === t.id ? 'text-accent-navy' : 'text-text-muted'}`}>{t.label}</p>
                <p className="text-[10px] text-text-muted leading-relaxed mt-0.5 hidden sm:block">{t.description}</p>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Beneficiary name */}
      <div>
        <label className="block text-[10px] font-black uppercase tracking-widest text-text-muted mb-1.5">
          {selectedType ? `${selectedType.label} Name *` : 'Beneficiary Name *'}
        </label>
        <div className="relative">
          <SafeIcon icon={FiUser} className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-text-muted" />
          <input type="text" value={form.beneficiary_name} onChange={e => update('beneficiary_name', e.target.value)}
            placeholder="Full name or organisation name…"
            className={`${inputCls} pl-10`} />
        </div>
      </div>

      {/* Conditional detail fields */}
      <AnimatePresence>
        {selectedType && selectedType.fields.length > 0 && (
          <motion.div key={selectedType.id} initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}
            className="space-y-4 overflow-hidden">
            <p className="text-[10px] font-black uppercase tracking-widest text-accent-navy">Additional Details</p>
            {selectedType.fields.map(f => (
              <div key={f.key}>
                <label className="block text-[10px] font-black uppercase tracking-widest text-text-muted mb-1.5">{f.label}</label>
                <input type="text" value={form.beneficiary_details?.[f.key] || ''}
                  onChange={e => updateDetail(f.key, e.target.value)}
                  placeholder={f.label}
                  className={inputCls} />
              </div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CampaignBeneficiaryFields;